export default __webpack_public_path__ + "static/cruiselines-vv-activities-6-400ee96610393435b48df5a574b8841f.jpg";